import { AllowedUserFieldsEnum } from 'shared/accountNameConfig'
import React from 'react'
import { useLingui } from '@lingui/react'
import { t } from '@lingui/macro'

export const useTranslatedFieldsLabels = (): Record<
  AllowedUserFieldsEnum,
  string
> => {
  const { i18n } = useLingui()
  return React.useMemo(
    () => ({
      [AllowedUserFieldsEnum.FIRST_NAME]: t`First name`,
      [AllowedUserFieldsEnum.LAST_NAME]: t`Last name`,
      [AllowedUserFieldsEnum.DISPLAY_NAME]: t`Display name`,
      [AllowedUserFieldsEnum.EMAIL]: t`Email`,
      [AllowedUserFieldsEnum.PHONE_NUMBER]: t`Mobile number`,
      [AllowedUserFieldsEnum.ACCOUNT_NAME]: t`Account name`,
      [AllowedUserFieldsEnum.POSITION]: t`Position`,
      [AllowedUserFieldsEnum.AREA]: t`Area`,
      [AllowedUserFieldsEnum.LOCATION]: t`Location`,
      [AllowedUserFieldsEnum.DEPARTMENT]: t`Department`,
      [AllowedUserFieldsEnum.CUSTOM_1]: t`Custom 1`,
      [AllowedUserFieldsEnum.CUSTOM_2]: t`Custom 2`,
      [AllowedUserFieldsEnum.CUSTOM_3]: t`Custom 3`
    }),
    [i18n.locale]
  )
}
